export default __webpack_public_path__ + "d0742949eff6a2f9748d8437061827ad.svg";